import { type FC } from "react";

import { useMutation } from "@apollo/client/react";

import { DraftingTemplateDefaultDocument } from "@app_schema";

import { track } from "@application/utilities/track";

import { Button } from "@styled/button";
import { ErrorLine } from "@styled/error_line";
import { NoticeLine } from "@styled/notice_line";

// Under "Upload your template" while he has none: his template from the
// General default instead. The tab then starts the case from a copy of it.
export const DraftingDefaultStart: FC<{ projectId: string }> = ({
  projectId,
}) => {
  const [start, { loading, error }] = useMutation(
    DraftingTemplateDefaultDocument,
    {
      variables: { id: projectId },
      refetchQueries: ["DashboardProjectsDetails"],
    },
  );

  return (
    <>
      <Button
        type="button"
        color="white"
        loading={loading}
        onClick={() =>
          void start()
            .then(() =>
              track("drafting_default_template_chosen", {
                project_id: projectId,
              }),
            )
            .catch(() => undefined)
        }
      >
        Start from the default template
      </Button>
      {error && <ErrorLine>{error.message}</ErrorLine>}
    </>
  );
};

// The setup card's last line: whose template he's setting up.
export const DraftingTemplateOwner: FC<{ clinician: string }> = ({
  clinician,
}) => (
  <NoticeLine>
    This is the template of {clinician}, the clinician on this case.
  </NoticeLine>
);
